import { render, staticRenderFns } from "./TabShipmentPlanning.vue?vue&type=template&id=9882a1e4&"
import script from "./TabShipmentPlanning.vue?vue&type=script&lang=js&"
export * from "./TabShipmentPlanning.vue?vue&type=script&lang=js&"
import style0 from "./TabShipmentPlanning.vue?vue&type=style&index=0&id=9882a1e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports